import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const SettingsContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  free_shipping_threshold: 45,
  shipping_fee: 4.9,
  announcements: [],
  announcements_nl: [],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => setSettings({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext) || DEFAULTS;
